import { Accordion } from './Accordion';
import { Alert } from './Alert';
import { Badge } from './Badge';
import { breadcrumbTheme as Breadcrumb } from './Breadcrumb';
import { Button } from './Button';
import { Card } from './Card';
import { Carousel } from './Carousel';
import { Checkbox } from './Checkbox';
import { Divider } from './Divider';
import { DragAndDrop, DropZoneStyle } from './DragAndDrop';
import { Drawer } from './Drawer';
import { Form } from './Form';
import { FormError } from './FormError';
import { FormLabel } from './FormLabel';
import { Heading } from './Heading';
import { Icon } from './Icon';
import { ImageComponent } from './Image';
import { Input } from './Input';
import { Link } from './Link';
import { List } from './List';
import { Menu } from './Menu';
import { Modal } from './Modal';
import { NumberInput } from './NumberInput';
import { Popover } from './Popover';
import { Progress } from './Progress';
import { Radio } from './Radio';
import { Select } from './Select';
import { Slider } from './Slider';
import { Switch } from './Switch';
import { Table } from './Table';
import { Tabs } from './Tab';
import { Tag } from './Tag';
import { Textarea } from './Textarea';
import { Tooltip } from './Tooltip';
import { VideoPlayer } from './VideoPlayer';

export const components = {
  Accordion,
  Alert,
  Badge,
  Breadcrumb,
  Button,
  Card,
  Carousel,
  Checkbox,
  Divider,
  DragAndDrop,
  DropZoneStyle,
  Drawer,
  Form,
  FormError,
  FormLabel,
  Heading,
  Icon,
  Image: ImageComponent,
  Input,
  Link,
  List,
  Menu,
  Modal,
  NumberInput,
  Popover,
  Progress,
  Radio,
  Select,
  Slider,
  Switch,
  Table,
  Tabs,
  Tag,
  Textarea,
  Tooltip,
  VideoPlayer,
};
